import React, { useEffect, useState } from 'react';
import { CheckCircle2, Circle } from 'lucide-react';
import { loadCheckedDocuments, normalizeDocumentLabel, saveCheckedDocuments } from '../../lib/opportunityUi';

export function RequiredDocumentsChecklist({
  opportunityId,
  documents,
}: {
  opportunityId: string;
  documents: string[];
}) {
  const [checked, setChecked] = useState<Set<string>>(() => loadCheckedDocuments(opportunityId));

  useEffect(() => {
    saveCheckedDocuments(opportunityId, checked);
  }, [checked, opportunityId]);

  const toggle = (doc: string) => {
    setChecked((prev) => {
      const next = new Set(prev);
      if (next.has(doc)) next.delete(doc);
      else next.add(doc);
      return next;
    });
  };

  const readyCount = documents.filter((doc) => checked.has(doc)).length;

  return (
    <div className="wfx-opp-docs-checklist">
      <p className="wfx-muted wfx-opp-docs-progress">
        {readyCount} of {documents.length} documents ready
      </p>
      <ul>
        {documents.map((doc) => {
          const label = normalizeDocumentLabel(doc);
          const isChecked = checked.has(doc);
          return (
            <li key={doc}>
              <button type="button" className={`wfx-opp-doc-item${isChecked ? ' is-checked' : ''}`} onClick={() => toggle(doc)}>
                {isChecked ? <CheckCircle2 size={18} aria-hidden="true" /> : <Circle size={18} aria-hidden="true" />}
                <span>{label}</span>
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
